export async function triggerNotification(title: string, body: string) {
  try {
    const registration = await navigator.serviceWorker.getRegistration();
    if (!registration) return;

    registration.showNotification(title, {
      body,
      icon: "/favicon.png",
      badge: "/dymaxtech.png",

    });
  } catch (err) {
    console.error("Notification error:", err);
  }
}
